import {
  DateSorting,
  OppsNameSorting,
  DateFiltering,
  QuarterYearSorting,
  clientAccountNameSorting,
} from '@util/commonFunctions';
import { TABLE_HEADER_SUBTEXT } from '@constants/commonConstants';

export const columnDefs = quarterData => {
  return [
    {
      field: 'commit_status',
      headerName: 'Commit',
      cellRenderer: 'toggleSwicthRenderer',
      cellRendererParams: params => {
        const awd = params.data.awd;
        const awd_period = params.data.fiscal_quarter;
        const ey_id = params.data.ey_id;
        const fiscal_year = params.data.fiscal_year;
        const month = params.data.fiscal_month;
        const opportunity_id = params.data.opportunity_id;
        const quarterDataObj = quarterData;
        const tov = params.data.tov;
        return {
          awd,
          awd_period,
          ey_id,
          fiscal_year,
          month,
          opportunity_id,
          quarterDataObj,
          tov,
        };
      },
      pinned: 'left',
      sortable: false,
      suppressMenu: true,
      suppressMovable: true,
      width: 135,
    },
    {
      field: 'ey_id',
      headerName: 'ID',
      cellRenderer: 'textCellRendererE',
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 110,
    },
    {
      field: 'pursuit_type',
      headerName: 'Pursuit Type',
      cellRenderer: 'pursuitTypeCellRenderer',
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 170,
    },
    {
      field: 'opportunity_name',
      headerName: 'Opportunity Name',
      cellRenderer: 'textLinkRenderer',
      cellRendererParams: params => {
        const ey_id = params.data.ey_id;
        const opportunity_id = params.data.opportunity_id;
        return { ey_id, opportunity_id };
      },
      tooltipField: 'opportunity_name', // Use the field value as the tooltip
      comparator: OppsNameSorting,
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 210,
    },
    {
      field: 'client_name',
      headerName: 'Client',
      cellRenderer: 'textCellRendererC',
      comparator: clientAccountNameSorting,
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 200,
    },
    {
      field: 'tov',
      headerName: 'TOV ($)',
      cellClass: 'cell-text-aligment',
      cellRenderer: 'textCellRendererD',
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 140,
    },
    {
      field: 'awd',
      headerName: 'AWD',
      cellRenderer: 'awd_Field_Rendere',
      cellRendererParams: params => {
        const awd = params.data.awd;
        const month = params.data.fiscal_month;
        const quarterDataObj = quarterData;
        return { awd, month, quarterDataObj };
      },
      comparator: DateSorting,
      filter: 'agDateColumnFilter',
      filterParams: DateFiltering,
      headerComponentParams: {
        subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
      },
      sortable: true,
      suppressMovable: true,
      width: 175,
    },
    {
      field: 'quarter_year',
      headerName: 'Quarter',
      cellClass: 'cell-text-aligment',
      cellRenderer: 'textCellRendererE',
      comparator: QuarterYearSorting,
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 140,
    },
    {
      field: 'stagecode_name',
      headerName: 'Stage',
      cellRenderer: 'textCellRendererE',
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 130,
    },
    {
      field: 'close_probablity',
      headerName: 'Prob(%)',
      cellClass: 'cell-text-aligment',
      cellRenderer: 'textCellRendererE',
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 140,
    },
    {
      field: 'account_name',
      headerName: 'Account',
      cellRenderer: 'textCellRendererC',
      comparator: clientAccountNameSorting,
      filter: 'agTextColumnFilter',
      sortable: true,
      suppressMovable: true,
      width: 200,
    },
    {
      field: 'comment',
      headerName: 'Comment',
      cellRenderer: 'commentColumnRenderer',
      sortable: false,
      suppressMenu: true,
      suppressMovable: true,
      width: 100,
    },
  ];
};
